// extracted by mini-css-extract-plugin
module.exports = {"Landing":"Landing_Landing__2yf0-"};